export default "__VITE_ASSET__848d0572__"